export default __webpack_public_path__ + "static/media/explore_white.c279b0d8.svg";